import { Col, Row, Tab } from "react-bootstrap";
import BreadCrumbs from "./BreadCrumbs";
import Header from "./Header";
import ConfirmCard from "./ConfirmTextCard";
import { areCookiesEnabled } from "../../cookies/cookies";
import CookiesDisabledCard from "./CookiesDisabledCard";

const Confirm = () => {
  const hasCookiesEnabled = areCookiesEnabled();

  return (
    <div>
      <BreadCrumbs />
      <div className="ps-0">
        <div className="pb-4">
          <Header />
        </div>
        <Row>
          <Col className="col-12">
            <div className={"tab"}>
              <Tab.Container id="confirmContent" defaultActiveKey={"default"}>
                <Tab.Content>
                  <Tab.Pane eventKey="default">
                    {hasCookiesEnabled && <ConfirmCard />}
                    {!hasCookiesEnabled && <CookiesDisabledCard />}
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Confirm;
